import { axiosInstance, axiosAuthenticate } from './xhrConfig';

const Subscription = {

  subscribe: (email) =>
    axiosInstance.post(`/api/subscription/subscribe/`, { email }),
};

export default Subscription;